module.exports = __webpack_public_path__ + "media/images/icon_arrow_gray-44f5fc0d0b061d7820e6b4953b730639.png";